import styled from 'styled-components'

export const Container = styled.div`
  width:100%;
  background-color: white;
  //min-height: 40px;
  border-radius: 16px;
  .imgBg{
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    width:100%;
    height: 48vw;
    background-repeat:no-repeat;
    background-size:48vw;
    background-position:center;
  }
  
  .title{
    width:90%;
    font-size:16px ;
    margin: 8px auto;
  }
  .textRightBottom{
    color: darkgray;
    width:43vw;
    height: 48vw;
    display: table-cell;
    vertical-align: bottom;
    text-align: right;
  }

  .textLeftBottom{
    color: darkgray;
    width:43vw;
    height: 48vw;
    display: table-cell;
    vertical-align: bottom;
    text-align: left;
   // background-color: white;
  }

  .textLeftBottomVideo{
    color: darkgray;
    width:43vw;
    height: 42vw;
    display: table-cell;
    vertical-align: bottom;
    text-align: left;
  }
  .textCenterVideo{
    color: darkgray;
   justify-content: center;
    align-items: center;
    height: 42vw;
    display: flex;
  }

  .textLeftTopVideo{
    color: darkgray;
    width: 80px;
    height: 20px;
    text-align: center;
    background-color: white;
    border-top-left-radius: 16px;
  }
  
  .imgCenter{
    height: 42vw;
    display: table-header-group;
    vertical-align: middle;
    text-align: center;
  }
  .userName{
    height: 32px;
    line-height: 16px;
    width:100%;
    font-size:12px ;
    color: darkgray;
  }
 
  .divider{
    margin-top:0;
    margin-bottom:8px;
  }
  .grid{
    height: 40px;
  }
  .voteCount{
    height: 32px;
    line-height: 16px;
    width:100%;
    text-align:right;
    font-size:16px ;
    color: #36BEF1;
  }



`
